<template>
  <div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">运单查询</div>
      </div>
      <div>
        <div class="table_item_box">
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">运单号</div>

              <input
                v-model="screen.ordernumber"
                type="text"
                placeholder="请输入运单号"
                class="table_item_input"
              />
            </div>
          </div>
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">国内单号</div>

              <input
                v-model="screen.domesticnumber"
                type="text"
                placeholder="请输入国内单号"
                class="table_item_input"
              />
            </div>
           
          </div>
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">退运单号</div>

              <input
                v-model="screen.secondtracknumber"
                type="text"
                placeholder="请输入国际段运单号"
                class="table_item_input"
              />
            </div>
          
          </div>
        
          <div class="table_item_box_s" style="flex-direction: column-reverse">
            <div class="table_item_box_l_r"></div>
            <div class="table_item_box_l_s">
              <el-button type="primary" @click="search" round>搜索</el-button>
              <el-button @click="reset" round>重置</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">已退运包裹列表</div>
      </div>
      <div class="table_box">
        <el-table
           v-loading='tableLoading'
          :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
          :data="orderData.content"
          stripe
          style="width: 100%"
        >
          <el-table-column align="center" prop="datecreated" label="创建日期">
          </el-table-column>
          <el-table-column align="center" prop="ordernumber" label="单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="domesticnumber"
            label="国内单号"
          >
          </el-table-column>
          <el-table-column align="center" prop="returnNumber" label="退运单号">
          </el-table-column>
          <el-table-column align="center" prop="returnCarrier" label="退运快递公司">
          </el-table-column>
          <el-table-column align="center" prop="returnUserName" label="退运收件人">
          </el-table-column>
          <el-table-column align="center" prop="shippingcost" label="总运费">
          </el-table-column>
          <el-table-column align="center" label="转运状态">
            <template slot-scope="scope">
              <el-button type="text">已退运</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" label="详情" width="150">
            <template slot-scope="scope">
              <el-button type="text" @click="details(scope.row.id)"
                >查看详情</el-button
              >
               <el-button @click="logistics(scope.row)" type="text"
                >物流详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging_box">
        <el-pagination
          @current-change="pageChange"
          background
          layout="prev, pager, next"
          :total="orderData.totalElements"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
export default {
  data() {
    return {
      tableLoading:'',
      dialogVisible: true,
      screenText: "",
      orderData: [],
      screen: {
      page: 1,
        size: 10,
        ordernumber: "",
        domesticnumber: "",
        state: 75,
      },
      circuitData:[],
    };
  },
  created() {
    this.orderList();
  },
  methods: {
          // 物流详情
    logistics(item) {
      localStorage.setItem("order", JSON.stringify(item));
      this.$router.push({
        path:
          "/logistics/logistics?code=" +
          item.domesticcarrier +
          "&num=" +
          item.domesticnumber,
      });
    },
    //分页
    pageChange(e) {
      this.screen.page = e;
      this.orderList();
    },
    //查看详情
    details(e) {
      this.$router.push({
        path: "/parcel/parcelDetail?id=" + e + "&name=待退运",
      });
    },
    //筛选
    clickScreen() {},
    showDialog() {
      this.dialogVisible = true;
    },
    //订单列表
    orderList() {
      this.tableLoading=true;
      crudDept.orderList(this.screen).then((res) => {
        this.orderData = res;
          this.tableLoading=false;
      }).catch((res)=>{
          this.tableLoading=false;
      })
    },
    //筛查
    search() {
      this.orderList();
    },
    reset() {
      this.screen = {
        page: 1,
        size: 10,
        ordernumber: "",
        domesticnumber: "",
       state:75
      };
      this.orderList();
    },
    // 线路
    circuit() {
      var data = {
        page: 1,
        size: 100,
      };
      crudDept.circuit(data).then((res) => {
        this.circuitData = res.content;
        res.content.map((item) => {
          item.value = item.id;
          item.label = item.name;
        });
        this.circuitData = res.content;
      });
    },
  },
};
</script>
<style scoped>
.confirm_btn {
  margin: 0 auto !important;
  background-color: #5178ff;
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  border-radius: 22px;
}
.textarea {
  margin: 7px 0 23px;
}
.text_btn {
  margin: 0 auto !important;
  display: block;
}
.el-button.is-round {
  border-radius: 14px;
  width: 110px;
  height: 40px;
}
.table_box {
  margin-top: 32px;
}
input {
  background-color: #fff;
}
.inout_uio {
  width: 502px;
  height: 40px;
  background: #fff !important;
  opacity: 1;
  border-radius: 5px 0 0 5px;
  padding: 0 15px;
  box-sizing: border-box;
  border-top: 1px solid #5178ff;
  border-left: 1px solid #5178ff;
  border-bottom: 1px solid #5178ff;
  border-right: none;
}
.button_L {
  border-radius: 0px 5px 5px 0px !important;
  background-color: #5178ff !important;
  border-color: #5178ff !important;
}
.fill_in_list_box {
  display: flex;
  flex-wrap: wrap;
}
.fill_in_list {
  /* width: 27%; */
  border-bottom: 1px solid #dedede;
  /* padding-bottom: 10px; */
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 16px;
  margin-right: 22px;
}
.fill_in_list_l {
  display: flex;
  align-items: baseline;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.input_select {
  width: 100%;
  height: 40px;
  background: #ffffff;

  border: none;
  opacity: 1;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select >>> .el-input__inner {
  border: none !important;
  padding: 0 !important;
  width: 100% !important;
}
.table_item_box {
  display: flex;
  align-items: flex-end;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  padding: 25px 0 0;
  box-sizing: border-box;
}
.table_item_box_l {
  margin-right: 30px;
  text-align: left;
}
.table_item_box_l_r {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /* margin-bottom: 20px; */
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #ffffff;

  border: 1px solid #dedede;
  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select {
  width: 100%;
  height: 40px;
  background: #ffffff;

  border: none;
  opacity: 1;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.table_item_box_l_r >>> .el-input__inner {
  border: none !important;
  padding: 0 !important;
  width: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/views/salessSeturn/accomplish.vue